import UIkit from "uikit";
//import Icons from "uikit/dist/js/uikit-icons";
import Icons from "./uikit-icons-custom";


// loads the Icon plugin
UIkit.use(Icons);


window.UIkit = UIkit;


document.onreadystatechange = () => {
    if (document.readyState === "complete") {
      setTimeout(function() {
        document.querySelector("body").classList.remove("yw-loading");
      }, 400);
    }
  };




  // How long you want the animation to take, in ms
  const animationDuration = 2000;
  // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
  const frameDuration = 1000 / 60;
  // Use that to calculate how many frames we need to complete the animation
  const totalFrames = Math.round( animationDuration / frameDuration );
  // An ease-out function that slows the count as it progresses
  const easeOutQuad = t => t * ( 2 - t );
  
  // The animation function, which takes an Element
  const animateCountUp = el => {
      let frame = 0;
      const countTo = parseInt( el.innerHTML, 10 );
      // Start the animation running 60 times per second
      const counter = setInterval( () => {
          frame++;
          // Calculate our progress as a value between 0 and 1
          // Pass that value to our easing function to get our
          // progress on a curve
          const progress = easeOutQuad( frame / totalFrames );
          // Use the progress value to calculate the current count
          const currentCount = Math.round( countTo * progress );
  
          // If the current count has changed, update the element
          if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
              el.innerHTML = currentCount;
          }
  
          // If we’ve reached our last frame, stop the animation
          if ( frame === totalFrames ) {
              clearInterval( counter );
          }
      }, frameDuration );
  };
  
  
  UIkit.util.ready(function() {
    UIkit.util.$$('.countup').forEach(function(el) {
      UIkit.scrollspy(el, { repeat: false });
       UIkit.util.on(el,'inview', function(){
          animateCountUp(el);
      });
    });
   });
   
   UIkit.icon.add('twitter','<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>');